import React, { memo } from "react";
import { Divider, HStack, Wrap, Text, VStack } from "@chakra-ui/react";
import {
  InfoIcon,
  ChatBubbleDotIcon,
  PinOutlineIcon,
  PaperclipIcon,
  FileBoxIcon,
  InboxOutlineIcon,
} from "modules/icons";
import colors from "app/colors";
import { SearchFilter, SearchFilterType } from "gql/graphql";
import FiltersDrawerToggleButton from "modules/messaging/search/filters-drawer-toggle-button";
import FiltersDrawerCalloutSelector from "./filters-drawer-callout-selector";
import FiltersDrawerDateRangeSelector from "./filters-drawer-date-range-selector";

interface IProps {
  newSearchFilters: SearchFilter[];
  setNewSearchFilters: React.Dispatch<React.SetStateAction<SearchFilter[]>>;
}

const AllThreadFilters = ({
  newSearchFilters,
  setNewSearchFilters,
}: IProps) => (
  <VStack w="full" spacing={6} divider={<Divider />}>
    <VStack w="full">
      <HStack w="full">
        <InfoIcon fill={colors.blackSecondary} boxSize={5} />
        <Text
          fontFamily="Outfit"
          color={colors.blackSecondary}
          fontSize={18}
          fontWeight={600}
        >
          Attributes
        </Text>
      </HStack>
      <Wrap w="full">
        <FiltersDrawerToggleButton
          title="Unread"
          icon={<ChatBubbleDotIcon fill={colors.gray50} boxSize={4} />}
          searchFilterType={SearchFilterType.IsNotSeenByMe}
          newSearchFilters={newSearchFilters}
          setNewSearchFilters={setNewSearchFilters}
        />
        <FiltersDrawerToggleButton
          title="Pinned"
          icon={<PinOutlineIcon fill={colors.gray50} boxSize={4} />}
          searchFilterType={SearchFilterType.IsPinnedByMe}
          newSearchFilters={newSearchFilters}
          setNewSearchFilters={setNewSearchFilters}
        />
        <FiltersDrawerToggleButton
          title="Attachments"
          icon={<PaperclipIcon fill={colors.gray50} boxSize={4} />}
          searchFilterType={SearchFilterType.HasAttachments}
          newSearchFilters={newSearchFilters}
          setNewSearchFilters={setNewSearchFilters}
        />
        <FiltersDrawerToggleButton
          title="Inbox"
          icon={<InboxOutlineIcon fill={colors.gray50} boxSize={4} />}
          searchFilterType={SearchFilterType.IsInbox}
          newSearchFilters={newSearchFilters}
          setNewSearchFilters={setNewSearchFilters}
        />
        <FiltersDrawerToggleButton
          title="Archived"
          icon={<FileBoxIcon fill={colors.gray50} boxSize={4} />}
          searchFilterType={SearchFilterType.IsNotInbox}
          newSearchFilters={newSearchFilters}
          setNewSearchFilters={setNewSearchFilters}
        />
      </Wrap>
    </VStack>
    <FiltersDrawerCalloutSelector
      newSearchFilters={newSearchFilters}
      setNewSearchFilters={setNewSearchFilters}
    />
    <FiltersDrawerDateRangeSelector
      title="Date Message Sent"
      startDateSearchFilterType={SearchFilterType.StartDate}
      endDateSearchFilterType={SearchFilterType.EndDate}
      dateRangeSearchFilterType={SearchFilterType.DateRangeType}
      newSearchFilters={newSearchFilters}
      setNewSearchFilters={setNewSearchFilters}
    />
  </VStack>
);

export default memo(AllThreadFilters);
